// ListOfCreatedUid.js
import React from 'react';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Sidebar from '../../../Navigation/Sidebar/Sidebar';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg";
import './ListOfCreatedUid.css';


const UidDashboardTimelineComponent = ({ uid, uidTimelineDetails }) => {

console.log("uid", uidTimelineDetails?.timeline)

  // Helper function to convert UTC date to IST string
  const formatToIST = (utcDateString) => {
    if (!utcDateString) return "N/A";
    try {
      const date = new Date(utcDateString);
      // Convert to IST
      const istOffset = 5.5 * 60; // IST = UTC + 5:30 in minutes
      const istDate = new Date(date.getTime() + istOffset * 60 * 1000);
      return istDate.toLocaleString('en-GB', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (err) {
      return utcDateString;
    }
  };

  const navigate = useNavigate();
  return (
    <div className="list-created-uid-container">
      <Sidebar />
      <div className="list-created-uid-content">
        {/* Header Section */}
        <div className="list-timeline-uid-header">
          <Button
            className="back-button"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <img src={leftArrow} alt="Back" />
          </Button>

          <h1 className="main-title">
            Timeline of UID{" "}
            {uid}
          </h1>

        </div>

        {/* Table Section */}
        <div className="list-created-uid-table-section">
          <TableContainer component={Paper} className="table-container">
            <Table className="created-uids-table">
              <TableHead>
                <TableRow className="table-header-row">
                  <TableCell className="table-header-cell">S.No.</TableCell>
                  <TableCell className="table-header-cell">VM ID</TableCell>
                  <TableCell className="table-header-cell">VM Name</TableCell>
                  <TableCell className="table-header-cell">Admin Name</TableCell>
                  <TableCell className="table-header-cell">Date[From]</TableCell>
                  <TableCell className="table-header-cell">Date[To]</TableCell>
                  <TableCell className="table-header-cell">Reason</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uidTimelineDetails?.timeline && uidTimelineDetails?.timeline.map((item, index) => (
                  <TableRow key={item.vendingMachineId} className="table-data-row">
                    <TableCell className="table-data-cell sno-cell">{index + 1}</TableCell>
                    <TableCell className="table-data-cell uid-cell">{item.vendingMachineId}</TableCell>
                    <TableCell className="table-data-cell uid-cell">{item.vendingMachineName}</TableCell>
                    <TableCell className="table-data-cell admin-cell">{item.createdByName}</TableCell>
                    <TableCell className="table-data-cell date-cell">{formatToIST(item.createdAt)}</TableCell>
                    <TableCell className="table-data-cell date-cell">{formatToIST(item.lastUpdatedAt)}</TableCell>
                    <TableCell className="table-data-cell date-cell">{item.unmappedReason}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>


      </div>
    </div>
  );
};

export default UidDashboardTimelineComponent;